interface ButtonAriaProps {
  type?: string;
  label?: string;
  href?: string;
  target?: string;
  ariaLabel?: string;
  rel?: string;
  disabled?: boolean;
  tabIndex?: string;
}

const getAriaProps = ({
  type,
  label,
  href,
  target,
  ariaLabel,
  rel,
  disabled,
  tabIndex,
}: ButtonAriaProps): Record<string, string | boolean> => {
  const normalizedRel = (rel || '') + (target === '_blank' ? ' noopener noreferrer' : '')

  return {
    'aria-label': ariaLabel || label || '',
    ...(normalizedRel && { rel: normalizedRel }),
    ...(disabled ? { 'aria-disabled': true, tabIndex: '-1' } : { tabIndex: tabIndex || '0' }),
    ...(!href && { type }),
  }
}

export default getAriaProps
